import CalendarField from '@modules/formFields/CalendarField'
import SelectField from '@modules/formFields/SelectField'
import moment from 'moment'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'

class AnalyticsSample extends Component {
  static defaultProps = {
    meta: {},
    input: {},
  }

  getOptions = () => [
    {
      id: 'today',
      name: this.props.t('Hoy'),
      startDate: moment().startOf('day').toDate(),
      endDate: moment().endOf('day').toDate(),
      sampleRate: 'hour',
    },
    {
      id: 'yesterday',
      name: this.props.t('Ayer'),
      startDate: moment().add(-1, 'day').startOf('day').toDate(),
      endDate: moment().add(-1, 'day').endOf('day').toDate(),
      sampleRate: 'hour',
    },
    {
      id: 'thisWeek',
      name: this.props.t('Esta semana'),
      startDate: moment().startOf('week').toDate(),
      endDate: moment().endOf('week').toDate(),
      sampleRate: 'day',
    },
    {
      id: 'lastWeek',
      name: this.props.t('Semana pasada'),
      startDate: moment().add(-1, 'week').startOf('week').toDate(),
      endDate: moment().add(-1, 'week').endOf('week').toDate(),
      sampleRate: 'day',
    },
    {
      id: 'last7Days',
      name: this.props.t('Últimos 7 días'),
      startDate: moment().add(-7, 'days').startOf('day').toDate(),
      endDate: moment().endOf('day').toDate(),
      sampleRate: 'day',
    },
    {
      id: 'lastMonth',
      name: this.props.t('Últimos 30 días'),
      startDate: moment().add(-30, 'days').startOf('day').toDate(),
      endDate: moment().endOf('day').toDate(),
      sampleRate: 'day',
    },
    {
      id: 'last3Months',
      name: this.props.t('Últimos 3 meses'),
      startDate: moment().add(-3, 'month').startOf('month').toDate(),
      endDate: moment().endOf('day').toDate(),
      sampleRate: 'month',
    },
    {
      id: 'lastYear',
      name: this.props.t('Últimos 12 meses'),
      startDate: moment().add(-12, 'month').startOf('month').toDate(),
      endDate: moment().endOf('day').toDate(),
      sampleRate: 'month',
    },
    {
      id: 'custom',
      name: this.props.t('Personalizado'),
      startDate: moment().startOf('week').toDate(),
      endDate: moment().endOf('day').toDate(),
      sampleRate: 'day',
    },
  ]

  state = {
    maxDate: moment().toDate(),
    minDate: moment('01/01/2016').toDate(),
  }

  onInputChange = (values) => {
    this.props.input.onChange({ ...values, id: 'custom' })
  }

  render() {
    const { maxDate, minDate } = this.state
    const { meta, t } = this.props

    return (
      <>
        <div className={`analytics-sample ${meta.touched && meta.error && 'error-validation'}`}>
          <div className="sample-selector">
            <SelectField
              clearable={false}
              backspaceRemoves={false}
              options={this.getOptions()}
              input={{
                value: this.props.input.value.id,
                onChange: this.props.input.onChange,
              }}
            />
          </div>

          <CalendarField
            maxDate={maxDate}
            minDate={minDate}
            input={{
              value: this.props.input.value.startDate,
              onChange: (date) => this.onInputChange({ ...this.props.input.value, startDate: date }),
              onFocus: () => null,
              onBlur: () => null,
            }}
          />

          <CalendarField
            maxDate={maxDate}
            minDate={minDate}
            input={{
              value: this.props.input.value.endDate,
              onChange: (date) => this.onInputChange({ ...this.props.input.value, endDate: date }),
              onFocus: () => null,
              onBlur: () => null,
            }}
          />

          <SelectField
            clearable={false}
            backspaceRemoves={false}
            simpleValue
            input={{
              value: this.props.input.value.sampleRate,
              onChange: (sampleRate) => this.onInputChange({ ...this.props.input.value, sampleRate }),
            }}
            options={[
              { id: 'hour', name: t('Hora') },
              { id: 'day', name: t('Dia') },
              // {id: 'week', name: t('Semana')},
              { id: 'month', name: t('Mes') },
            ]}
          />
        </div>
        {/*{ meta.touched && meta.error && <span style={ {color: 'red'} } className="error">{ meta.error }</span> }*/}
      </>
    )
  }
}

export default withTranslation()(AnalyticsSample)

export const validateSampleField = (values, props) => {
  if (values) {
    if (!values.endDate || !values.startDate) return 'Rango de fechas no especificado'

    let xAxisPoints = moment(values.endDate).endOf('day').diff(moment(values.startDate), values.sampleRate)

    if (xAxisPoints < 0) return 'Rango de fechas invalido'
    if (xAxisPoints < 1) return 'Gráfica sin información'
    if (xAxisPoints > 99) return 'Gráfica demasiado extensa'
  }
  return undefined
}
